import React, { Component } from "react";
import { toast } from "react-toastify";

import Back from "../../common/form/back";

import {
  createFolder,
  getFolders,
  updateFolder,
} from "../../../services/fileService";

class FolderForm extends Component {
  state = {
    data: {
      name: "",
    },
  };

  // Retrive the Data from the Server
  async componentDidMount() {
    // Get the Given ID
    const folderName = this.props.match.params.id;
    if (folderName === "new") return;

    // Get Folder
    const { data: allFolders } = await getFolders("public");
    const folder = allFolders.find((name) => name === folderName);
    if (!folder) return this.props.history.replace("/not-found");

    this.setState({
      data: this.mapToViewModel(folder),
    });
  }

  // Map current Folder to the Folder name input
  mapToViewModel(folder) {
    return {
      name: folder,
    };
  }

  // Create a New Folder function
  handleCreate = async () => {
    const folder = this.state.data.name;

    try {
      const response = await createFolder(folder);

      if (response.data && response.status === 200) {
        toast.success(response.message);
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error("A Folder with that name already exists!");
      } else if (ex.response && ex.response.status === 500) {
        toast.error(ex.response.data.message);
      }
      return;
    }
    this.props.history.push("/dashboard/folders");
  };

  // Save
  handleSave = async () => {
    const newFolderName = this.state.data.name;
    const currentFolderName = this.props.match.params.id;

    try {
      const response = await updateFolder(newFolderName, currentFolderName);
      if (response.data && response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 401) {
        toast.error("Only admins can update a Folder!");
      } else if (ex.response && ex.response.status === 404) {
        toast.error("This Folder has already been updated.");
      } else if (ex.response && ex.response.status === 500) {
        toast.error(ex.response.data.message);
      }
    }
    this.props.history.push("/dashboard/folders");
  };

  // Selecet Input event handler
  handleChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };

    data[input.name] = input.value;

    this.setState({ data });
  };

  // Back button Event Handler
  handleBack = () => {
    this.props.history.push("/dashboard/folders");
  };

  render() {
    const id = this.props.match.params.id;
    const { data } = this.state;

    return (
      <div className="col alt-table-responsive mt-1 mb-1">
        <div className="row align-items-center mt-1 mb-2 underline">
          <div className="col mt-2">
            <h2 className="mt-2">
              <i className="bx bxs-folder"></i>{" "}
              {id === "new" ? "Create a new Folder" : "Edit Folder Details"}
            </h2>
          </div>
        </div>

        <div className="row align-items-center pt-2 my-2">
          <div className="col-sm-6">
            <label for="basic-url">
              {id === "new" ? "Folder Name" : "New Name"}
            </label>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span
                  className="input-group-text left-rounded"
                  id="folder-name"
                >
                  public/
                </span>
              </div>
              <input
                type="text"
                name="name"
                className="form-control right-rounded"
                placeholder={id}
                value={data.name}
                id="basic-url"
                aria-describedby="folder-name"
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div className="col-sm-6"></div>
        </div>

        <hr />

        <div className="row justify-content-between align-items-center mt-3 pb-2">
          <div className="col">
            <Back onClick={this.handleBack} />
          </div>

          <div className="col text-end">
            {id === "new" && (
              <button
                className="btn btn-success rounded"
                onClick={this.handleCreate}
                disabled={data.name !== "" ? false : true}
              >
                <i className="fa fa-plus" aria-hidden="true"></i> Create
              </button>
            )}
            {id !== "new" && (
              <button
                className="btn btn-success rounded"
                onClick={this.handleSave}
              >
                <i className="fa fa-floppy-o" aria-hidden="true"></i> Save
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FolderForm;
